// Group G9's words: the record page grammar (docs/PAGE-GRAMMAR.md, F-185) — the way back to the section a record was
// opened from, the neighbours in that section's list, a list card's way to everything it shortens, and the name of a
// card's own menu. Each entry quotes the line of his glossary it is taken from; labels.test.mjs checks every quote,
// text and status. Card titles, tab names and status words come from the screens' own tables and the shared module.

import { defineLabels, template, type LabelSource } from "../labels";

const his = <const S extends string>(text: S, source: LabelSource, quote: string) =>
  ({ text, source, quote, status: "his" }) as const;

/** F-147 (DC-232): the link that returns to the list a record was opened from. */
const GO_BACK = "| Go back to Requisitions | The link at the top of the Assign/reassign Recruiter page, under the breadcrumb, that returns to the Requisitions list";
const PREVIOUS = "reopen preserves previous closure history.";
const NEXT = "Next path (alternate to offer / continue / reopen / close)";
const ALL = "F each control · E chips \"All\" · L —";
const ACTIONS = "Actions and controls (verbs he uses for what a user does)";

/** The record header's navigation: the neighbours in the list, the card menu's name. */
export const G9_LABELS = /* @__PURE__ */ defineLabels({
  previous: his("Previous"),
  next: his("Next"),
  actions: his("Actions"),
});

export const G9_TEMPLATES = {
  /** "Back to Requisitions", "Back to Interviews": the section the record was opened from. */
  backTo: /* @__PURE__ */ template({ text: "Back to {section}" }),
  /** A list card's footer link: everything the card shortens to five rows. */
  allOf: /* @__PURE__ */ template({ text: "All {what}" }),
} as const;
